export enum Layers {
    Customers = "states-layer",
    Beach = "beach-layer",
    Contract = "contract-layer"    
}
